import { FIELD_NAMES } from "apps/signup/util/constants";
import { STEPS } from "apps/onboarding/util/constants";
import { FIELDS } from "apps/what_i_want/util/constants";

// map some field values to official names
const _signupFieldNameMap = {
	[FIELD_NAMES.gender]: "Gender",
	[FIELD_NAMES.orientation]: "Orientation",
	[FIELD_NAMES.location]: "Location",
	[FIELD_NAMES.birthday]: "Birthdate",
	[FIELD_NAMES.email]: "Email",
	[FIELD_NAMES.screenname]: "Username",
	[FIELD_NAMES.password]: "Password",
	[FIELD_NAMES.captcha]: "Captcha",
};

const _onboardingFieldNameMap = {
	[STEPS.ESSAY]: "Essay",
	[STEPS.QUESTIONS]: "Questions",
	[STEPS.LIKES]: "Likes",
	[STEPS.PHOTOS]: "Photo",
	[STEPS.QUESTIONS_CONVO]: "Questions Chat",
	[STEPS.QUESTIONS]: "Questions Card",

	// wiw fields
	[FIELDS.LOOKINGFOR]: "Desired Relationship",
	[FIELDS.AGE]: "Desired Age",
	[FIELDS.GENDER]: "Desired Gender",
	[FIELDS.DISTANCE]: "Desired Distance",
};

const EVENT_NAMES = {
	...(typeof window.EVENT_NAMES !== "undefined" ? window.EVENT_NAMES : {}),

	getQuestionsSetGenre(genre) {
		if (genre === null) {
			return "Unset questions category";
		} else {
			return `Set questions category to ${genre}`;
		}
	},


	// some things will be getters
	getOnboardingValidatedField(fieldName) {
		const field = _signupFieldNameMap[fieldName];

		if (field) {
			return `Validated signup field - ${field}`;
		} else {
			return null;
		}
	},

	getOnboardingFailedValidationField(fieldName) {
		const field = _signupFieldNameMap[fieldName];

		if (field) {
			return `Failed to validate signup field - ${field}`;
		} else {
			return null;
		}
	},

	getOnboardingStepEventName(stepName) {
		const eventName = _onboardingFieldNameMap[stepName];

		if (eventName === _onboardingFieldNameMap[STEPS.QUESTIONS_CONVO]) {
			// this one has a special name
			return EVENT_NAMES.onboardingQuestionsCompleted;
		} else if (stepName === STEPS.QUESTIONS) {
			return EVENT_NAMES.onboardingQuestionsCardCompleted;
		} else if (eventName) {
			return `Selected next on Onboarding ${eventName}`;
		} else {
			return null;
		}
	},

	recaptchaScore: "Score for Recaptcha V3",
	reachedDailyLikes: "reached daily likes limit",
	connectionLayerShown: "connection layer shown",
	votedAfterLikesCapLimit: "voted after likes cap limit",
	paymentLinkLearnMore: "clicked on payment link learn more",
	selectedOptionOnNavBar: "selected option on navbar",
};

export default EVENT_NAMES;



// WEBPACK FOOTER //
// ./src/analytics/util/EventNames.js